import angular from 'angular';
// import mainWebSocketWorker from "./main_worker";
import connectCentrifugo from "./centrifugo_worker";

let mmApp = angular.module('mmApp');

mmApp.run(['$rootScope', '$timeout', '$log', 'CurrentUser', connectCentrifugo]);
